import { render, staticRenderFns } from "./DisableAuthProviderModal.vue?vue&type=template&id=32927268&"
import script from "./DisableAuthProviderModal.vue?vue&type=script&lang=js&"
export * from "./DisableAuthProviderModal.vue?vue&type=script&lang=js&"
import style0 from "./DisableAuthProviderModal.vue?vue&type=style&index=0&id=32927268&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports